module.exports = __webpack_public_path__ + "img/whatsapp.d501a592.svg";